export type Language = "fr" | "en" | "ar" | "zh" | "es" | "ru"

export const allLanguages: Language[] = [ "en", "fr", "es", "zh", "ar", "ru"]

export const languageOf = (lang:Language) => `intl.${lang}`